//import './mobile-switch.scss'
import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAtom } from 'jotai'
import { analyticsCurrentAction } from '@store/atoms.ts'
import thank from '@assets/Thank_you.png'
import thankMobile from '@assets/Thank you_mobile.png'
import Header from '@ui/richiesta/Header'


const MobileSwitchPage: React.FC = () => {
	const [queryParams] = useSearchParams()
	const [currentAnalytics, setCurrentAnalytics] = useAtom(
		analyticsCurrentAction
	)
	const [searchParams] = useSearchParams()

	/* need to trigger it before any useEffect, but we dont want to set it every
	 * time the page is re-rendered (which shouldnt happen in this case, but
	 *  better safe than sorry) */
	if (currentAnalytics !== 'none' && Boolean(searchParams.get('mobile'))) {
		setCurrentAnalytics('StepChangeToTablet')
	} else if (currentAnalytics !== 'none') {
		setCurrentAnalytics('none')
	}

	return (
		<div>
			<Header hideClose={true} />
		
		
	<div className="flex flex-col items-center text-center gap-4 mt-16">

			{queryParams.get('mobile') === 'true' ? (
				<div className='px-6 md:px-0'>
					<h2 className='text-(--primary-blue) text-[28px] md:text-[40px] font-semibold'>
						Grazie! Ci vediamo sul tuo computer
					</h2>

					<img src={thankMobile} className='mx-auto block' alt=''/>
					<p className='font-medium md:text-[18px]'>
						Hai scelto di completare la richiesta sul tuo computer, ora puoi chiudere questa pagina
					</p>
				</div>
				
			) : (
				<>
				<h2 className='text-(--primary-blue) text-[28px] md:text-[40px] font-semibold'>
				Grazie! Ci vediamo sul tuo smartphone o tablet
			</h2>

			<img src={thank}></img>
					<p className='font-medium md:text-[18px]'>
						Hai scelto di completare la richiesta sul tuo smartphone, ora puoi chiudere questa pagina
					</p>
				</>
			)}
		</div>

		</div>
	)
}

export { MobileSwitchPage }
